/* Cart drawer promo block: rotates the social proof line, counts down to the
   customer's local midnight and mirrors the discount message into the drawer's
   live region.

   The drawer header is re-rendered via innerHTML after every cart change, so
   this element is destroyed and recreated each time. Everything it owns is set
   up in connectedCallback and torn down in disconnectedCallback. The live
   region deliberately lives OUTSIDE the replaced subtree (in
   snippets/cart-drawer.liquid): a region inserted together with its own new
   text is not announced by most screen readers. */
if (!customElements.get('m-cart-promo')) {
  class MCartPromo extends HTMLElement {
    connectedCallback() {
      this.startRotator();
      this.startCountdown();
      this.announce();
    }

    disconnectedCallback() {
      (this.rotateTimers || []).forEach(clearInterval);
      this.rotateTimers = [];
      if (this.countdown && this.countdown.timer) clearInterval(this.countdown.timer);
      this.countdown = null;
    }

    startRotator() {
      this.rotateTimers = [];

      this.querySelectorAll('.m-cart-promo__rotator').forEach((rotator) => {
        const slides = [...rotator.querySelectorAll('[data-slide]')];
        if (slides.length < 2) return;

        const interval = parseInt(rotator.dataset.rotateInterval, 10) || 3000;
        let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (index < 0) index = 0;

        this.rotateTimers.push(
          setInterval(() => {
            const leaving = slides[index];
            index = (index + 1) % slides.length;

            leaving.classList.remove('is-active');
            leaving.classList.add('is-above');
            slides[index].classList.add('is-active');

            /* Send the outgoing slide back below the line once it is out of
               sight, so its next entrance travels upwards like the first one. */
            setTimeout(() => leaving.classList.remove('is-above'), MCartPromo.TRANSITION_MS);
          }, interval)
        );
      });
    }

    startCountdown() {
      const CountdownTimer = window.MinimogTheme && window.MinimogTheme.CountdownTimer;
      if (!CountdownTimer || !this.querySelector('.countdown-timer-sec')) return;
      /* 'every_day' resolves to the next local 00:00: with a 24h interval the
         only start point is hour 0, which is never still ahead today, so the
         timer rolls over to midnight tomorrow. See getEvergreenDueDate in
         assets/theme-global.js before changing either side. */
      this.countdown = new CountdownTimer(this, Date.now(), 0, { type: 'evergreen', duration: 'every_day' });
      this.countdown.update();
    }

    /* Announce the discount message only when it actually changed, and never on
       the very first render - that would talk over the page load. */
    announce() {
      const region = document.getElementById(this.dataset.statusTarget);
      const message = this.dataset.message;
      if (!region || !message) return;

      if (region.dataset.seen === undefined) {
        region.dataset.seen = message;
        return;
      }
      if (region.dataset.seen === message) return;

      region.dataset.seen = message;
      region.textContent = message;
    }
  }

  /* Keep in step with the transition on .m-cart-promo__slide. */
  MCartPromo.TRANSITION_MS = 400;

  customElements.define('m-cart-promo', MCartPromo);
}
